import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { translate } from 'react-i18next';
import * as Common from 'common/components';
import * as DisabledReport from 'reports/components/disabled';
import { saveAsCSV } from 'lib/util';
import { getDisabledReportXLSX, getDisabledReportCSV, getDisabledReportPDF } from '../../actions/disabled_report_actions';
import { generateDisabledPDF } from '../../../../../../lib/pdfs/DisabledPDF';
import FileSaver from 'file-saver';
import moment from 'moment';

class ReportsDepreciationHeader extends PureComponent {
  static propTypes = {
    companyId: PropTypes.string.isRequired,
    subcompanyId: PropTypes.string.isRequired,
    t: PropTypes.func.isRequired,
    filters: PropTypes.object.isRequired,
    getDisabledReportCSV: PropTypes.func.isRequired,
    getDisabledReportXLSX: PropTypes.func.isRequired,
    getDisabledReportPDF: PropTypes.func.isRequired,
  };

  handleExport = () => {
    const { companyId, subcompanyId, filters, getDisabledReportCSV } = this.props;

    getDisabledReportCSV(companyId, subcompanyId, filters)
      .then(({ value: { data } }) => saveAsCSV(`depreciacion`, filters.endDate, data))
      .catch((error) => {
        console.error('Error al exportar CSV:', error);
      });
  };

  /* handleExportXLSX = () => {
    const { companyId, subcompanyId, filters, getDisabledReportXLSX } = this.props;

    getDisabledReportXLSX(companyId, subcompanyId, filters)
      .then(({ value }) => {
        if (
          value &&
          value.data &&
          value.data instanceof Uint8Array
        ) {
          const dataArray = new Uint8Array(value.data);
          const blob = new Blob([dataArray], {
            type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
          });
          FileSaver.saveAs(blob, `depreciacion-${moment().format('DDMMYYYY')}.xlsx`);
        } else {
          console.error('La respuesta no contiene datos válidos:', value);
        }
      })
      .catch((error) => {
        console.error('Error al exportar XLSX:', error);
      });
  }; */

  handleExportPDF = () => {
    const { companyId, subcompanyId, filters, getDisabledReportPDF } = this.props;

    getDisabledReportPDF(companyId, subcompanyId, filters)
      .then(({ value: { data } }) => generateDisabledPDF(
          this.props.companyId,
          this.props.subcompanyId,
          this.props.filters.endDate,
          this.props.filters.depreciationType,
          data
        )
      )
      .catch((error) => {
        console.error('Error al exportar PDF:', error);
      });
  };

  render() {
    const { companyId, subcompanyId, t } = this.props;

    return (
      <Common.Header title={t('reports.disabled.title')}>
        <DisabledReport.Header
          companyId={companyId}
          subcompanyId={subcompanyId}
          handleExport={this.handleExport}
          handleExportXLSX={this.handleExportXLSX}
          handleExportPDF={this.handleExportPDF}
        />
      </Common.Header>
    );
  }
}

const mapStateToProps = (state) => ({});

const mapDispatchToProps = {
  getDisabledReportCSV,
  getDisabledReportXLSX,
  getDisabledReportPDF,
};

export default connect(mapStateToProps, mapDispatchToProps)(translate()(ReportsDepreciationHeader));



// WEBPACK FOOTER //
// src/modules/secured/modules/reports/components/disabled/DisabledReportHeader.js